import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEn from './locales/en.json'; // 英文语言包
import translationZh from './locales/zh.json'; // 中文语言包
import translationIna from './locales/ina.json';// 印尼语言包
import translationRu from './locales/ru.json';// 俄语语言包
import translationFr from './locales/fr.json'; //法语语言包
import translationEs from './locales/es.json'; //西班牙语语言包
import translationTh from './locales/th.json'; //西班牙语语言包
import translationMs from './locales/ms.json'; //马来语
import translationPt from './locales/pt.json'; //葡语
import translationVi from './locales/vi.json'; //越南语
import translationAr from './locales/ar.json'; //阿拉伯语
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: translationEn,
      },
      zh: {
        translation: translationZh,
      },
      ina: {
        translation: translationIna,
      },
      ru_RU:{
        translation: translationRu,
      },
      fr_FR:{
        translation: translationFr,
      },
      es_ES:{
        translation: translationEs,
      },
      th_TH:{
        translation: translationTh,
      },
      ms_MS:{
        translation: translationMs,
      }
      ,
      pt_PT:{
        translation: translationPt,
      }
      ,
      vi_VI:{
        translation: translationVi,
      },
      ar_AR:{
        translation: translationAr,
      }
    },
    lng: localStorage.getItem('languageType'), // 默认语言
    fallbackLng: 'zh', // 当没有找到匹配语言时，使用的语言
    interpolation: {
      escapeValue: false,
    },
  });
export default i18n;
// {
//   "hello": "Hello",
//   "world": "World"
// }
// {
//   "hello": "你好",
//   "world": "世界"
// }